import { Component } from '@angular/core';

@Component({
  selector: 'app-dashboard-icon',
  standalone: true,
  host: { class: 'ui-icon' },
  templateUrl: './dashboard-icon.component.html',
  styleUrl: '../icon-base.scss'
})
export class DashboardIconComponent {}
